const colors = {
  black: "#000000",
  white: "#ffffff",
  orange: "#E4503B",
  cream: "#F9EDC8",
}

export default colors
